<template>
	<div data-app class="qna-report-list">
		<PageHeader :title="`${typeConsts.label} 신고 목록`">
			총 {{ Util.format(counter.totalCount) }} | 대기
			{{ Util.format(counter.waitCount) }} | 완료
			{{ Util.format(counter.completeCount) }}
		</PageHeader>
		<form @submit.prevent="search(0)">
			<ManagingSection :columnCount="2">
				<ManagingBox title="검색">
					<SelectInput
						ref="SearchType"
						:defaultSelectValue="searchType"
						:selectList="parsedSearchTypeList"
						@change="searchTypeChange"
					/>
				</ManagingBox>
				<ManagingBox title="신고일">
					<DateRange v-model="createdAt" type="date" />
				</ManagingBox>
				<ManagingBox title="처리상태">
					<RadioList v-model="state" :radioList="stateList" />
				</ManagingBox>
				<ManagingBox title="신고사유">
					<Selector
						v-model="code"
						:optionList="staticCodes"
						valueKey="code"
						class="section__info__items"
					/>
				</ManagingBox>
			</ManagingSection>
			<div class="btn-wrap-main">
				<button type="submit" class="btn-main blue" v-text="'검색'" />
				<button
					type="button"
					class="btn-main"
					v-text="'초기화'"
					@click="initSearch"
				/>
			</div>
		</form>
		<ManagingSection :isTable="true">
			<template slot="infoSection">
				<div class="section__info__left">
					검색 결과 {{ totalCount.toLocaleString() }}건
				</div>
				<div class="section__info__right">
					<button
						v-if="!isUserType"
						:disabled="!checkList.length"
						type="button"
						class="btn orange section__info__items"
						v-text="'일괄차단'"
						@click="activeModal"
					/>
				</div>
			</template>
			<table class="table-main">
				<thead>
					<tr>
						<th
							v-if="!isUserType"
							class="qna-report-list__table-checkbox-item"
						>
							<input
								v-model="allCheckModel"
								:value="allCheck"
								type="checkbox"
							/>
						</th>
						<th class="qna-report-list__table-id-item">신고번호</th>
						<th class="qna-report-list__table-date-item">
							신고일시
						</th>
						<th class="qna-report-list__table-nickname-item">
							작성자
						</th>
						<th
							v-if="isUserType"
							class="qna-report-list__table-state-item"
							v-text="'회원상태'"
						/>
						<th v-else>신고내용</th>
						<th class="qna-report-list__table-cnt-item">
							총 신고수
						</th>
						<th class="qna-report-list__table-code-item">
							신고사유
						</th>
						<th class="qna-report-list__table-nickname-item">
							신고자
						</th>
						<th
							v-if="!isUserType"
							class="qna-report-list__table-state-item"
							v-text="`${typeConsts.label}상태`"
						/>
						<th class="qna-report-list__table-state-item">
							처리상태
						</th>
						<th class="qna-report-list__table-date-item">
							처리일시
						</th>
						<th
							v-if="typeConsts.parentLabel"
							class="qna-report-list__table-id-item"
							v-text="`${typeConsts.parentLabel}번호`"
						/>
					</tr>
				</thead>
				<tbody v-if="list.length">
					<tr v-for="item in list" :key="item.id">
						<td v-if="!isUserType">
							<input
								v-model="checkListModel"
								:value="item[typeConsts.refType].id"
								type="checkbox"
								:disabled="
									item[typeConsts.refType].state === '차단' ||
									item[typeConsts.refType].deleted_at
								"
							/>
						</td>
						<td>
							<template v-if="isUserType">{{ item.id }}</template>
							<RouterLink
								v-else
								:to="`/qna/${type}/report/${item.id}`"
								class="link"
								v-text="item.id"
							/>
						</td>
						<td>{{ item.created_at | dateFormat }}</td>
						<td>
							<RouterLink
								v-if="item[typeConsts.refType].register"
								:to="`/register/register-info/${item[typeConsts.refType].register.idRegister}`"
								target="_blank"
								class="link"
								v-text="
									item[typeConsts.refType].register.nickName
								"
							/>
						</td>
						<td v-if="!isUserType">
							<pre class="text-left">{{ item.text }}</pre>
						</td>
						<td v-if="isUserType">
							{{ item.qna_register_state_log.state || '정상' }}
						</td>
						<td>{{ item.reportCount }}</td>
						<td>
							<template v-if="isUserType">
								{{ item.static_code.name }}
							</template>
							<RouterLink
								v-else
								:to="`/qna/${type}/report/${item.id}`"
								class="link"
								v-text="item.static_code.name"
							/>
						</td>
						<td>
							<RouterLink
								:to="`/register/register-info/${item.register.idRegister}`"
								target="_blank"
								class="link"
								v-text="item.register.nickName"
							/>
						</td>
						<td
							v-if="!isUserType"
							:class="
								item[typeConsts.refType].deleted_at
									? '삭제'
									: item[typeConsts.refType].state |
										stateClass
							"
							v-text="
								item[typeConsts.refType].deleted_at
									? '삭제'
									: item[typeConsts.refType].state
							"
						/>
						<td :class="item.state | stateClass">
							{{ item.state }}
						</td>
						<td>{{ item.updated_at | dateFormat }}</td>
						<td v-if="typeConsts.parentLabel">
							<RouterLink
								v-if="
									!item[typeConsts.refType][
										`${typeConsts.parentRefType}`
									].deleted_at
								"
								:to="`${parentTypeLink}/${item[typeConsts.refType][`${typeConsts.parentRefType}_id`]}`"
								target="_blank"
								class="link"
								v-text="
									item[typeConsts.refType][
										`${typeConsts.parentRefType}_id`
									]
								"
							/>
						</td>
					</tr>
				</tbody>
				<tbody v-else>
					<tr>
						<td :colspan="thLength">조회된 데이터가 없습니다.</td>
					</tr>
				</tbody>
			</table>
			<PaginationBox
				slot="pagination"
				:totalItem="totalCount"
				:limit="limit"
				:offset="offset"
				@to="search($event.offset)"
			/>
		</ManagingSection>
	</div>
</template>

<script>
	import _ from 'lodash';
	import moment from 'moment';
	import { mapState } from 'vuex';
	import Util from '@/lib/Util.js';
	import compact from 'lodash/compact';
	import PageHeader from '@/components/PageHeader.vue';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import SelectInput from '@/components/SelectInput.vue';
	import DateRange from '@/components/DateRange.vue';
	import RadioList from '@/components/RadioList.vue';
	import Selector from '@/components/Selector.vue';
	import PaginationBox from '@/components/PaginationBox.vue';

	export default {
		name: 'QnaReportList',
		components: {
			PageHeader,
			ManagingSection,
			ManagingBox,
			SelectInput,
			DateRange,
			RadioList,
			Selector,
			PaginationBox,
		},
		props: {
			type: {
				default: 'q', // q, a, c, user
				type: String,
			},
		},
		data() {
			const searchTypeList = [
				{ value: 'nickName', name: '신고자' },
				{ value: 'registerId', name: '신고회원번호' },
			];

			const stateList = [
				{ id: null, value: '전체' },
				{ id: '대기', value: '대기' },
				{ id: '완료', value: '완료' },
			];

			return {
				qnaReportType: {
					q: {
						refType: 'qna',
						label: '질문',
						link: '/qna/q',
						idName: 'qnaId',
					},
					a: {
						refType: 'qna_reply',
						label: '답변',
						parentRefType: 'qna',
						parentLabel: '질문',
						link: '/qna/a',
						idName: 'qnaReplyId',
						parentType: 'q',
					},
					c: {
						refType: 'qna_reply',
						label: '댓글',
						parentRefType: 'parent',
						parentLabel: '답변',
						link: '/qna/c',
						idName: 'qnaReplyId',
						parentType: 'a',
					},
					user: {
						refType: 'qna_register_state_log',
						label: '회원',
						link: '/qna/c',
					},
				},
				counter: {},
				list: [],
				searchTypeList,
				searchType: searchTypeList[0].value,
				searchValue: '',
				createdAt: {
					from: '',
					to: '',
				},
				stateList,
				state: stateList[0].id,
				code: null,
				totalCount: 0,
				limit: 50,
				offset: 0,
				allCheck: false,
				checkList: [],
			};
		},
		computed: {
			...mapState({
				staticCodes: state => [
					{ code: null, name: '전체' },
					...state.filter.staticCodes.filter(
						item => item.parent_code === 'QNA_REPORT'
					),
				],
			}),
			isUserType() {
				return this.type === 'user';
			},
			typeConsts() {
				return this.qnaReportType[this.type];
			},
			parentTypeLink() {
				return this.qnaReportType[this.typeConsts.parentType].link;
			},
			parsedSearchTypeList() {
				return compact([
					...this.searchTypeList,
					this.isUserType
						? null
						: {
								value: this.typeConsts.idName,
								name: `${this.typeConsts.label}번호`,
							},
				]);
			},
			thLength() {
				return (
					(this.isUserType ? 10 : 12) -
					(this.typeConsts.parentLabel ? 0 : 1)
				);
			},
			allCheckModel: {
				get() {
					return this.allCheck;
				},
				set(allCheck) {
					this.checkList = allCheck
						? this.list
								.filter(
									item =>
										item[this.typeConsts.refType].state !==
										'차단'
								)
								.map(item => item[this.typeConsts.refType].id)
						: [];
					this.allCheck = allCheck;
				},
			},
			checkListModel: {
				get() {
					return this.checkList;
				},
				set(checkList) {
					this.allCheck =
						this.list.filter(
							item =>
								item[this.typeConsts.refType].state !== '차단'
						).length === checkList.length;
					this.checkList = checkList;
				},
			},
		},
		mounted() {
			this.init();
		},
		methods: {
			setFilter() {
				const query = this.$route.query;

				if (query.searchType) {
					this.searchType = query.searchType;
					this.$refs.SearchType.selectModel = query.searchType;
				}

				if (query.searchValue) {
					this.searchValue = query.searchValue;
					this.$refs.SearchType.inputModel = query.searchValue;
				}

				this.createdAt = {
					from: query.startCreatedAt || '',
					to: query.endCreatedAt || '',
				};

				if (query.state) {
					this.state = query.state;
				}

				if (query.code) {
					this.code = query.code;
				}

				if (query.offset) {
					this.offset = Number(query.offset);
				}
			},
			async loadCounter() {
				const { data } = await this.$axiosAdmin2.get(
					'/api/qna/report/state/count',
					{ params: { target: this.typeConsts.label } }
				);
				this.counter = data;
			},
			getParams() {
				const params = {
					target: this.typeConsts.label,
					offset: this.offset,
					limit: this.limit,
				};

				if (this.searchValue) {
					params[this.searchType] = this.searchValue;
				}

				if (this.createdAt.from) {
					params.startCreatedAt = moment(
						this.createdAt.from
					).toISOString();
				}

				if (this.createdAt.to) {
					params.endCreatedAt = moment(this.createdAt.to)
						.add(1, 'd')
						.add(-1, 's')
						.toISOString();
				}

				if (this.state) {
					params.state = this.state;
				}

				if (this.code) {
					params.code = this.code;
				}

				return params;
			},
			setQuery() {
				const query = {};

				if (this.searchType !== this.searchTypeList[0].value) {
					query.searchType = this.searchType;
				}

				if (this.searchValue) {
					query.searchValue = this.searchValue;
				}

				if (this.createdAt.from) {
					query.startCreatedAt = this.createdAt.from;
				}

				if (this.createdAt.to) {
					query.endCreatedAt = this.createdAt.to;
				}

				if (this.state !== this.stateList[0].id) {
					query.state = this.state;
				}

				if (this.code !== this.staticCodes[0].code) {
					query.code = this.code;
				}

				if (this.offset) {
					query.offset = String(this.offset);
				}

				this.$router.replace({ query }).catch(() => {});
			},
			async setList() {
				this.loadCounter();
				const params = this.getParams();
				const { data } = await this.$axiosAdmin2.get(
					'/api/qna/report',
					{ params }
				);
				this.list = data.qnaReportList;
				this.totalCount = data.totalCount;
			},
			init() {
				this.setFilter();
				this.setList();
			},
			search(offset) {
				this.offset = offset;

				this.setQuery();
				this.setList();
			},
			initSearch() {
				this.$refs.SearchType.init();
				(this.searchType = this.searchTypeList[0].value),
					(this.searchValue = '');
				this.createdAt = {
					from: '',
					to: '',
				};
				this.state = this.stateList[0].id;
				this.code = this.staticCodes[0].code;
				this.search(0);
			},
			searchTypeChange({ select, input }) {
				this.searchType = select;
				this.searchValue = input;
			},
			modalComplete() {
				this.$store.commit('modal/toggleModal', false);
				this.allCheckModel = false;
				this.checkListModel = [];
				this.search(0);
			},
			activeModal() {
				this.$store.commit('modal/toggleModal', {
					id: 'QnaStateBatchBlock',
					params: {
						ids: this.checkList,
						type: this.typeConsts.label,
						modalComplete: this.modalComplete,
					},
				});
			},
		},
	};
</script>
<style lang="scss" scoped>
	.qna-report-list {
		&__table-checkbox-item {
			width: 28px;
		}

		&__table-id-item,
		&__table-cnt-item,
		&__table-state-item {
			width: 70px;
		}

		&__table-date-item,
		&__table-nickname-item {
			width: 120px;
		}

		&__table-code-item {
			width: 200px;
		}
	}
</style>
